// JsFromRoutes CacheKey c71caf158c84206c2a954028b84dab1d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/medical_plan_ingestions'),
}
